import React from "react";

import { Icon, IconProps } from "../";

export const ReceiptCheckedIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 2H22C22.6 2 23 2.4 23 3V11C23 11.6 22.6 12 22 12H21C20.4 12 20 11.6 20 11C20 10.5 20.5 10 21 10V4H3V10C3.6 10 4 10.4 4 11C4 11.6 3.6 12 3 12H2C1.4 12 1 11.6 1 11V3C1 2.4 1.4 2 2 2ZM18 6H6C5.45 6 5 6.46 5 7.03V20.92C5 21.69 5.79 22.18 6.45 21.84L8.54 20.76C8.83 20.61 9.17 20.61 9.46 20.76L11.54 21.88C11.83 22.04 12.18 22.04 12.47 21.88L14.55 20.76C14.84 20.61 15.18 20.6 15.47 20.76L17.56 21.84C18.23 22.19 19 21.69 19 20.92V7.03C19 6.46 18.56 6 18.01 6H18ZM8.0199 12.5481C8.3128 12.2552 8.78767 12.2552 9.08056 12.5481L11.0858 14.5533L14.9194 10.7197C15.2123 10.4268 15.6872 10.4268 15.9801 10.7197C16.273 11.0126 16.273 11.4874 15.9801 11.7803L11.6161 16.1443C11.3232 16.4372 10.8483 16.4372 10.5554 16.1443L8.0199 13.6088C7.72701 13.3159 7.72701 12.841 8.0199 12.5481Z"
      />
    </Icon>
  );
};
